import { useSwipeable } from 'react-swipeable';
import { useNavigate } from 'react-router-dom';

const Entrees = ({ language }: { language: string }) => {
  const navigate = useNavigate();

  // Configuration améliorée du swipe
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      navigate('/main');
    },
    onSwipedRight: () => {
      navigate('/Drinks');
    },
    trackMouse: true,
    delta: 50, // Distance minimale pour déclencher le swipe
    trackTouch: true
  });


  return (
    <div
      className="min-h-screen flex flex-col items-center p-8 bg-cover bg-center bg-fixed pt-[110px]"
      style={{ backgroundImage: "url('/image/Lona2.jpg')" }}
      {...handlers} // Attachez les gestionnaires d'événements au div
    >
      <p className="text-center text-xs text-green-950 mt-2">
        {language === "fr" ? "Glissez pour naviguer" : "Swipe to navigate"}
      </p>

      {/* Liste avec carte style menu améliorée */}
      <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 max-w-2xl w-full shadow-lg mt-8">

        <ul className="space-y-6">
          {[
            {
              fr: "Hummus",
              en: "Hummus",
              priceFr: "8$",
              priceEn: "$8",
              descFr: "Crème onctueuse à base de pois chiches, ail et huile d'olive, garnie de noix de Grenoble et de graines de sésame.",
              descEn: "Creamy spread made with chickpeas, garlic, and olive oil, topped with walnuts and sesame seeds"
            },
            {
              fr: "Hmiss",
              en: "Hmiss",
              priceFr: "10$",
              priceEn: "$10",
              descFr: "une délicieuse préparation à base de poivrons grillés, tomates, ail et épices, le tout sublimé par une touche d'huile d'olive.",
              descEn: "A delicious spread made from roasted peppers, tomatoes, garlic, and spices, all enhanced with a drizzle of olive oil."
            },
            {
              fr: "Roulaux d’aubergine",
              en: "Eggplant rolls",
              priceFr: "14$",
              priceEn: "$14",
              descFr: "Trois roulaux d’aubergine grillée, farcis d’une savoureuse viande hachée assaisonnée, nappés d’une sauce maison riche et parfumée.",
              descEn: "Three grilled eggplant rolls stuffed with seasoned minced meat, topped with a rich and flavorful house sauce."
            },
            {
              fr: "Mini tarte tatin salé",
              en: "Mini salty tarte tatin",
              priceFr: "10$",
              priceEn: "$10",
              descFr: "Deux mini tartes tatin salées, avec des tomates et échalotes caramélisées, offrant une parfaite harmonie de saveurs sucrées et salées",
              descEn: "Two savory mini tartes tatin, with caramelized tomatoes and shallots, offering a perfect balance of sweet and savory flavors."
            }
          ].map((item, index) => (
            <li key={index} className="border-b border-gray-200 pb-4 last:border-0">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-bold text-lg">{language === "fr" ? item.fr : item.en}</h3>
                  {item.descFr && (
                    <p className="text-gray-600 text-sm mt-1">
                      {language === "fr" ? item.descFr : item.descEn}
                    </p>
                  )}
                </div>
                <span className="text-green-950 font-medium">
                  {language === "fr" ? item.priceFr : item.priceEn}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Entrees;
